import { UserActionType } from './enums';
import { type UserState, type UserAction } from './interfaces';

export const initialState: UserState = {
	error: false,
	loading: true,
	user: {},
	userPermissionsList: [],
	userPermissionsError: false,
	userPermissionsLoading: false,
	selectedUserPermissions: [],
	selectedUserPermissionsLoading: false,
	selectedUserPermissionsError: false,
	credits: 0,
	creditLimit: 0,
	creditsUsed: 0,
	creditsLoading: false,
	creditsError: null
};

export default (state = initialState, { type, payload }: UserAction): UserState => {
	switch (type) {
		case UserActionType.FETCH_USER_DETAILS:
			return {
				...state,
				error: false,
				loading: true
			};

		case UserActionType.STORE_USER_DETAILS:
			return {
				...state,
				error: false,
				loading: false,
				user: payload
			};

		case UserActionType.ERROR_USER_DETAILS:
			return {
				...state,
				error: true,
				loading: false
			};

		case UserActionType.UPDATE_USER_DETAILS:
			return {
				...state,
				error: false,
				loading: false
			};

		case UserActionType.UPDATE_PROFILE_PICTURE:
			return {
				...state,
				error: false,
				loading: false
			};
		//user permissions

		case UserActionType.FETCH_USER_PERMISSIONS:
			return {
				...state,
				userPermissionsError: {},
				userPermissionsLoading: true
			};

		case UserActionType.STORE_USER_PERMISSIONS:
			return {
				...state,
				userPermissionsLoading: false,
				userPermissionsList: payload
			};

		case UserActionType.ERROR_USER_PERMISSIONS:
			return {
				...state,
				userPermissionsError: payload.error,
				userPermissionsLoading: false
			};

		case UserActionType.FETCH_SELECTED_USER_PERMISSIONS:
			return {
				...state,
				selectedUserPermissionsError: {},
				selectedUserPermissionsLoading: true
			};

		case UserActionType.STORE_SELECTED_USER_PERMISSIONS:
			return {
				...state,
				selectedUserPermissionsLoading: false,
				selectedUserPermissions: payload
			};

		case UserActionType.ERROR_SELECTED_USER_PERMISSIONS:
			return {
				...state,
				selectedUserPermissionsError: payload.error,
				selectedUserPermissionsLoading: false
			};

		case UserActionType.FETCH_CREDITS:
			return {
				...state,
				creditsLoading: true,
				creditsError: null
			};

		case UserActionType.STORE_CREDITS:
			return {
				...state,
				credits: payload.credits ?? state.credits,
				creditLimit: payload.creditLimit ?? state.creditLimit,
				creditsUsed: payload.creditsUsed ?? state.creditsUsed,
				creditsLoading: false,
				creditsError: null
			};

		case UserActionType.ERROR_FETCH_CREDITS:
			return {
				...state,
				creditsLoading: false,
				creditsError: payload.error
			};

		case UserActionType.UPDATE_CREDITS:
			return {
				...state,
				creditsLoading: true,
				creditsError: null
			};

		case UserActionType.UPDATE_CREDITS_SUCCESS:
			return {
				...state,
				credits: payload.credits ?? state.credits,
				creditsLoading: false,
				creditsError: null
			};

		case UserActionType.ERROR_UPDATE_CREDITS:
			return {
				...state,
				creditsLoading: false,
				creditsError: payload.error
			};

		default:
			return state;
	}
};
